import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaDescription from './media-description-model'
import {
  CreateMediaDescriptionAsync,
  DeleteMediaDescriptionAsync,
  LoadMediaDescriptionsAsync,
} from './mediaDescription-thunk'
const initialState: mediaDescriptionSliceState = {
  mediaDescription: [],
  selected_mediaDescription: '',
  is_loading_mediaDescription: false,
  is_creating_mediaDescription: false,
  is_deleting_mediaDescription: false,
}
export interface mediaDescriptionSliceState {
  mediaDescription: MediaDescription[]
  selected_mediaDescription?: string
  is_loading_mediaDescription: boolean
  is_creating_mediaDescription: boolean
  is_deleting_mediaDescription: boolean
}
export const mediaDescriptionSlice = createSlice({
  name: 'mediaDescription',
  initialState,
  reducers: {
    setSelectedmediaDescription: (state, action) => {
      state.selected_mediaDescription = action.payload
    },
    clearStatemediaDescription: (state) => {
      state.mediaDescription = []
      state.is_loading_mediaDescription = false
      state.is_creating_mediaDescription = false
      state.is_deleting_mediaDescription = false
    },
    mergemediaDescription: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaDescription = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaDescription = merge(state.mediaDescription, payload) as any
        }
      }
    },

    add_mediaDescription: (state, action) => {
      if (action.payload) {
        state.mediaDescription = [...state.mediaDescription, action.payload]
      }
    },
    set_mediaDescription: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaDescription = state.mediaDescription.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaDescriptionsAsync.pending, (state) => {
      state.is_loading_mediaDescription = true
    })
    builder.addCase(LoadMediaDescriptionsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaDescription = false
      if (action.payload) {
        state.mediaDescription = action.payload
      }
    })
    builder.addCase(LoadMediaDescriptionsAsync.rejected, (state) => {
      state.is_loading_mediaDescription = false
    })
    builder.addCase(CreateMediaDescriptionAsync.pending, (state) => {
      state.is_creating_mediaDescription = true
    })
    builder.addCase(CreateMediaDescriptionAsync.fulfilled, (state) => {
      state.is_creating_mediaDescription = false
    })
    builder.addCase(CreateMediaDescriptionAsync.rejected, (state) => {
      state.is_creating_mediaDescription = false
    })
    builder.addCase(DeleteMediaDescriptionAsync.pending, (state) => {
      state.is_deleting_mediaDescription = true
    })
    builder.addCase(DeleteMediaDescriptionAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaDescription = false
      if (state.mediaDescription) {
        state.mediaDescription = state.mediaDescription.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaDescriptionAsync.rejected, (state) => {
      state.is_deleting_mediaDescription = false
    })
  },
})

export const {
  clearStatemediaDescription,
  setSelectedmediaDescription,
  set_mediaDescription,
  mergemediaDescription,
  add_mediaDescription,
} = mediaDescriptionSlice.actions

export const get_mediaDescription =
  (id?: string) =>
  (state: {
    mediaDescription: {
      mediaDescription: MediaDescription[]
    }
  }): MediaDescription | null => {
    let temp = state?.mediaDescription?.mediaDescription?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediaDescription?.mediaDescription[0] || null
  }
export const get_selected_mediaDescription = (state: {
  mediaDescription: mediaDescriptionSliceState
}): MediaDescription | null => {
  let id = state?.mediaDescription?.selected_mediaDescription
  let temp = state?.mediaDescription?.mediaDescription?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaDescription = (state: {
  mediaDescription: {
    mediaDescription: MediaDescription[]
  }
}): MediaDescription[] => {
  let temp = state?.mediaDescription?.mediaDescription
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaDescription_busy = (state: {
  mediaDescription: mediaDescriptionSliceState
}) => {
  return (
    state?.mediaDescription.is_deleting_mediaDescription ||
    state?.mediaDescription.is_loading_mediaDescription ||
    state?.mediaDescription.is_creating_mediaDescription
  )
}
export const is_deleting_mediaDescription_busy = (state: {
  mediaDescription: mediaDescriptionSliceState
}) => {
  return state?.mediaDescription.is_deleting_mediaDescription
}
export const is_loading_mediaDescription_busy = (state: {
  mediaDescription: mediaDescriptionSliceState
}) => {
  return state?.mediaDescription.is_loading_mediaDescription
}
export const is_creating_mediaDescription_busy = (state: {
  mediaDescription: mediaDescriptionSliceState
}) => {
  return state?.mediaDescription.is_creating_mediaDescription
}

export default mediaDescriptionSlice.reducer
